import { render, staticRenderFns } from "./relevanceDevicesDialog.vue?vue&type=template&id=77ca2bc5&scoped=true"
import script from "./relevanceDevicesDialog.vue?vue&type=script&lang=js"
export * from "./relevanceDevicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca2bc5",
  null
  
)

export default component.exports